/*eslint-disable */
import { useEffect } from 'react';
import { useFormikContext } from 'formik';

const FormikHelper = ({
  buildWhereClause,
  formEdited,
  lookupNames,
  onSubmitClicked,
  setFormEdited,
  setSubmitFlag,
  submitFlag,
  submitTranslation,
  resetFlag,
  setResetFlag,
}) => {
  const { dirty, values, resetForm } = useFormikContext();

  useEffect(() => {
    if (resetFlag === true) {
      resetForm(); // resets formik state
      setResetFlag(false);
    }
  }, [resetFlag]);

  useEffect(() => {
    if (dirty) {
      if (!formEdited) setFormEdited(true);
    } else if (formEdited) setFormEdited(false);
  }, [dirty]);

  useEffect(() => {
    if (submitFlag === true) {
      let submitValues = {};
      const keys = Object.keys(values);
      keys.forEach(k => {
        if (values[k] !== '') {
          const vKeys = Object.keys(values[k]);
          if (vKeys.length > 0) {
            if (lookupNames.lookupNames.find(f => f === k)) {
              const y = submitTranslation[k];
              submitValues = { ...submitValues, [y]: values[k] };
            } else {
              submitValues = { ...submitValues, [k]: values[k] };
            }
          }
        }
      });

      const whereClause = buildWhereClause(submitValues);
      const jsonBody = {
        where: whereClause,
      };
      onSubmitClicked(jsonBody);
    }
    return setSubmitFlag(false);
  }, [submitFlag]);

  return null;
};

export default FormikHelper;
